<div class="home-container">
  <!-- Loading overlay -->
  <umkt-loading [isLoading]="isLoading" [size]="'lg'" [showText]="false" mode="contained"></umkt-loading>

  <!-- Main content -->
  <div *ngIf="!isLoading && !error">
    <div class="banner-section">
      <umkt-banner-carousel [banners]="banners" (bannerClick)="onBannerClick($event)"></umkt-banner-carousel>
    </div>
    <div class="home-content-container">
      <section class="main-section">
        <div class="main-title-container font-highlight">
          <h2 class="main-title">
            <ng-container *ngIf="homeHeadline; else defaultHomeTitle">
              {{ homeHeadline }}
            </ng-container>
            <ng-template #defaultHomeTitle>
              {{ 'pages.home.title' | i18n }}
              <span class="highlight">{{ 'pages.home.titleHighlight' | i18n }}</span>
            </ng-template>
          </h2>

        </div>
        <p class="main-description">
          <ng-container *ngIf="homeSubheadline; else defaultHomeDescription">
            {{ homeSubheadline }}
          </ng-container>
          <ng-template #defaultHomeDescription>
            {{ 'pages.home.description' | i18n }}
          </ng-template>
        </p>
      </section>

      <section class="tabs-section">
        <umkt-tabs #tabsComponent [tabs]="tabs" [activeTabId]="activeTabIdSubject.value"
          (tabChange)="onCategoryChange($event)">
        </umkt-tabs>
      </section>

      <section class="category-section">
        <div class="category-loading-wrapper" *ngIf="isCategoryLoading">
          <umkt-loading [isLoading]="isCategoryLoading" [size]="'md'" [showText]="true" [text]="'pages.home.loadingProducts' | i18n"
            mode="contained"></umkt-loading>
        </div>

        <div class="category-header" *ngIf="!showNoResultsMessage && !isCategoryLoading">
          <h3 class="category-title">
            {{ getCurrentCategory()?.name }}
          </h3>
          <p class="category-description">
            {{ getCurrentCategory()?.description }}
          </p>
        </div>

        <umkt-carousel [items]="products" *ngIf="products.length > 0 && !showNoResultsMessage && !isCategoryLoading"
          id="category-item" #carousel>
          <ng-template #itemTemplate let-product>
            <umkt-product-card 
              [imageUrl]="product.imageUrl" 
              [title]="product.name" 
              [description]="product.excerpt"
              [priceLabel]="'pages.home.priceLabel' | i18n" 
              [price]="product.price" 
              [plans]="product.productType === 'MOVEL' ? [] : product.variations" 
              [productUuid]="product.uuid"
              [showAddToCart]="true"
              [showQuantitySelector]="product.productType !== 'MOVEL'" 
              [showLearnMore]="product.productType !== 'MOVEL'"
              [buyNowLink]="product.productType === 'MOVEL' ? product.link : ''"
              [addToCartTextOverride]="product.productType === 'MOVEL' ? ('components.productCard.buyNow' | i18n) : ''"
              (learnMore)="onLearnMore(product)"
              [productType]="product.productType"
              [productSku]="product.sku"
              [customFields]="product.customFields"
              (addToCart)="onAddToCartFromCard($event, product)"
              (click)="gtm.selectItem(getCurrentCategory()?.name || '', getCurrentCategory()?.name || '', { item_id: product.sku || product.uuid || product.id, item_name: product.name, item_category: getCurrentCategory()?.name || '', price: product.salesPrice ?? product.price ?? 0 })">
            </umkt-product-card>
          </ng-template>
        </umkt-carousel>

        <!-- No search results message -->
        <div *ngIf="showNoResultsMessage" class="no-results-message"
          style="display: block !important; visibility: visible !important; opacity: 1 !important;">
          <h4>{{ 'pages.home.noProducts' | i18n }}</h4>
          <p>{{ 'pages.home.noProductsDescription' | i18n }}</p>
        </div>
      </section>
    </div>
  </div>

  <!-- Error display -->
  <div *ngIf="!isLoading && error" class="error-container">
    <umkt-error-display [retryCount]="retryCount" (retry)="handleRetry()">
    </umkt-error-display>
  </div>
  
</div>